<script lang="ts">
	import ShellLayout from "./ShellLayout.svelte";
	import NewPresentation from "./NewPresentation.svelte";
</script>

<ShellLayout><NewPresentation /></ShellLayout>
